import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Icon,
  Tooltip,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import MDEditor from "./MDEditor";
import { Mail } from "@mui/icons-material";
import CrudService from "services/cruds-service";
import MDButton from "./MDButton";

export default function MailComposerDialog({
  loading = false,
  users,
  setNotification,
}) {
  const [open, setOpen] = useState(false);
  const [mailSubject, setSubject] = useState("");
  const [mailBody, setBody] = useState("");

  const sendEmail = async () => {
    try {
      const emails = users.map((item) => item.email);
      await CrudService.createItem(`api/mail`, {
        emails,
        mailSubject,
        mailBody,
      });
      setOpen(false);
      setNotification({
        value: true,
        color: "success",
        text: "تم الإرسال بنجاح",
      });
    } catch (err) {
      // it sends error is the category is associated with an item
      console.error(err);
      if (err.hasOwnProperty("errors")) {
        setNotification({
          value: true,
          color: "error",
          text: "حدث خطأ ما، الرجاء المحاولة مرة أخرى",
        });
      }
      return null;
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Compose Email</DialogTitle>

        <DialogContent dividers>
          <Box mb={2}>
            <TextField
              fullWidth
              label="Subject"
              value={mailSubject}
              onChange={(e) => setSubject(e.target.value)}
            />
          </Box>

          <Box data-color-mode="light">
            <MDEditor
              value={mailBody}
              onChange={(e) => setBody(e.target.value)}
              height={300}
            />
          </Box>
        </DialogContent>

        {/* Bottom action bar */}
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="inherit">
            إلغاء
          </Button>

          <Button onClick={sendEmail} variant="contained" disabled={loading}>
            إرسال
          </Button>
        </DialogActions>
      </Dialog>
      <MDButton
        onClick={() => setOpen(true)}
        variant="outlined"
        color={"info"}
        size="medium"
        iconOnly
        sx={{ mx: 1, width: "auto", padding: "6px 12px" }}
      >
        <Icon sx={{ fontWeight: "bold" }}>mail</Icon>
        &nbsp;
        <Tooltip title=" إرسال بريد إلكتروني ">
          <span>إرسال بريد إلكتروني </span>
        </Tooltip>
      </MDButton>
      {/* <IconButton size="large" onClick={() => setOpen(true)}>
        <Mail color="info" />
      </IconButton> */}
    </>
  );
}
